import privacyHtml from "./content/privacy.html?raw";
import { LegalPage } from "./LegalPage";
import { LATEST_LEGAL_VERSION } from "./version";
import { Seo } from "@/marketing/Seo";

export function PrivacyPage() {
  return (
    <>
      <Seo
        title="Privacy Policy — Tapelens"
        description="How Tapelens collects, uses, and protects your personal data."
        path="/legal/privacy"
      />
      <LegalPage title="Privacy Policy" lastUpdated={LATEST_LEGAL_VERSION} html={privacyHtml} />
    </>
  );
}
